import Notify from './notifyActions'

export const VALIDATE = 'VALIDATE'

export const postValidate = (data) => ({
  type: VALIDATE,
  payload: {
    request: {
      mode: 'no-cors',
      url: 'validatetoken',
      method: 'POST',
      data: {
        request: data
      }
    }
  }
})

export const RESET_PASSWORD = 'RESET_PASSWORD'

export const postResetPassword = (data) => ({
  type: RESET_PASSWORD,
  payload: {
    request: {
      mode: 'no-cors',
      url: 'resetPassword',
      method: 'POST',
      data: {
        request: data
      }
    }
  }
})

export const SEND_EMAIL = 'SEND_EMAIL'
export const FORGOT_PASSWORD_ERROR_NOUSER = 'forgot_password_error_nouser'


export const postSendEmail = (email) => {
  return (dispatch, getState) => {
    dispatch({
      type: SEND_EMAIL,
      payload: {
        request: {
          mode: 'no-cors',
          url: 'sendEmail',
          method: 'POST',
          data: {
            request: email
          }
        }
      }
    }).then(response => {
      if(!response.payload.data.sucess){
        if(response.payload.data.errors === 'error_nouser'){
          dispatch(Notify.error(FORGOT_PASSWORD_ERROR_NOUSER))
        }
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/redux/actions/passwordresetActions.js